export enum RepairOrderStatus {
  NoStatus = '',
  Responded = 'Responded',
  Sent = 'Sent',
}
